var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupHistoryLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_col"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.2329 72.724V27.1792H10.4023V72.724C10.4023 94.7337 28.2716 112.603 50.0634 112.603V92.5545C39.1675 92.5545 30.2329 83.8378 30.2329 72.724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M87.1085 112.603V48.0993L50.0625 25V49.4068L66.8422 59.431V112.603H87.1085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M128.516 112.603V48.0993L91.9062 25V49.4068L108.686 59.431V112.603H128.516Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupHistoryLogo2);
export default __webpack_public_path__ + "static/media/sup_history_logo2.7fe1fae7d5b7f47193f12c6f721323d5.svg";
export { ForwardRef as ReactComponent };